import { useEffect } from "react"
import Splash from "../../components/Splash"
import SevenSlide from "./components/SevenSlide"
import Slider from "./components/Slider"

const FirstSlide = ({ nextSlide }) => {
  return (
    <div
      onClick={nextSlide}
      className="h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 cursor-pointer overflow-hidden"
    >
      <Splash />
    </div>
  )
}

const ImageWrapper = ({ nextSlide, skipToEnd, imgSrc }) => {
  return (
    <div className="h-screen bg-gray-900 flex items-center justify-center overflow-hidden relative">
      {/* Blurred Background */}
      <div className="absolute inset-0">
        <img
          src={imgSrc || "/placeholder.svg"}
          alt="Background"
          className="w-full h-full object-cover object-center scale-110 blur-lg"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-6">
        <div className="bg-white/10 backdrop-blur-xl rounded-3xl border border-white/20 shadow-2xl">
          <img
            src={imgSrc || "/placeholder.svg"}
            alt="Onboarding content"
            className="w-full max-w-sm mx-auto rounded-2xl shadow-2xl"
          />
        </div>
      </div>

      {/* Next Button */}
      <button
        className="absolute bottom-8 right-8 px-6 py-3 bg-white/90 backdrop-blur-sm text-gray-900 rounded-full font-semibold text-lg shadow-lg hover:shadow-xl hover:bg-white transform hover:scale-105 transition-all duration-200 flex items-center gap-2 z-10"
        onClick={nextSlide}
      >
        Next
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>

      {/* Skip Button */}
      <button
        className="absolute top-8 right-8 px-4 py-2 text-white/80 hover:text-white text-sm font-medium transition-colors duration-200 bg-black/20 backdrop-blur-sm rounded-full z-10"
        onClick={skipToEnd}
      >
        Skip
      </button>
    </div>
  )
}

const slideTimer = 3 // in sec

const SLIDES = [
  {
    id: 1,
    type: "custom",
    component: FirstSlide,
    timer: slideTimer,
  },
  {
    id: 2,
    type: "image",
    imgSrc: "./assets/onboarding-slide-2.jpeg",
    timer: slideTimer,
  },
  {
    id: 3,
    type: "image",
    imgSrc: "./assets/onboarding-slide-3.png",
    timer: slideTimer,
  },
  {
    id: 4,
    type: "custom",
    component: ImageWrapper,
    imgSrc: "./assets/onboarding-slide-4.png",
  },
  {
    id: 5,
    type: "custom",
    component: ImageWrapper,
    imgSrc: "./assets/onboarding-slide-5.png",
  },
  {
    id: 6,
    type: "custom",
    component: ImageWrapper,
    imgSrc: "./assets/onboarding-slide-6.png",
  },
  {
    id: 7,
    type: "custom",
    component: SevenSlide,
  },
]

const OnboardingPage = () => {
  // Prevent scrolling during onboarding
  useEffect(() => {
    document.body.style.overflow = "hidden"
    return () => {
      document.body.style.overflow = "unset"
    }
  }, [])

  return (
    <div className="h-screen overflow-hidden bg-gray-900">
      <Slider slides={SLIDES} />
    </div>
  )
}

export default OnboardingPage
